import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import StatsRibbon from "@/components/StatsRibbon";
import ServicesSection from "@/components/ServicesSection";
import VideoSection from "@/components/VideoSection";
import TeamSection from "@/components/TeamSection";
import ReviewsSection from "@/components/ReviewsSection";
import WhoWeServe from "@/components/WhoWeServe";
import TestimonialSection from "@/components/TestimonialSection";
import CtaSection from "@/components/CtaSection";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <StatsRibbon />
      <ServicesSection />
      <VideoSection />
      <TeamSection />
      <WhoWeServe />
      <TestimonialSection />
      <ReviewsSection />
      <CtaSection />
      <Footer />
    </div>
  );
};

export default Index;
